// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-BrandCarousel-module__brandCarouselSection-Mw2gW {
  padding: 32px 0px;
  width: 100%;
  display: flex;
  gap: 32px;
  align-items: center;
  flex-direction: column;
  background-color: var(--background-secondary);
}

.nightbot-BrandCarousel-module__brandCarouselContainer-XqEpA {
  width: 100%;
  color: var(--mantine-color-gray-3);
}

.nightbot-BrandCarousel-module__brandLogo-QuuY4 {
  margin-right: 16px;
  margin-left: 16px;
  min-width: 100px;
  flex: 1;
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/BrandCarousel.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,OAAO;EACP,kBAAkB;AACpB","sourcesContent":[".brandCarouselSection {\n  padding: 32px 0px;\n  width: 100%;\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  flex-direction: column;\n  background-color: var(--background-secondary);\n}\n\n.brandCarouselContainer {\n  width: 100%;\n  color: var(--mantine-color-gray-3);\n}\n\n.brandLogo {\n  margin-right: 16px;\n  margin-left: 16px;\n  min-width: 100px;\n  flex: 1;\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandCarouselSection": `nightbot-BrandCarousel-module__brandCarouselSection-Mw2gW`,
	"brandCarouselContainer": `nightbot-BrandCarousel-module__brandCarouselContainer-XqEpA`,
	"brandLogo": `nightbot-BrandCarousel-module__brandLogo-QuuY4`
};
export default ___CSS_LOADER_EXPORT___;
